import React, { createRef } from 'react';
import { render } from 'react-dom';
import angular from 'angular';
import { withProviders } from '../../../core/components';
import { CallOverlay, } from './call-overlay';
export default angular
    .module('doxy.call.call-overlay', [])
    .component('callOverlay', {
    template: '<div></div>',
    bindings: {
        hasAudio: '<',
        hasVideo: '<',
    },
    controller: function ($element) {
        const ref = createRef();
        const OverlayWithProviders = withProviders(({ hasAudio, hasVideo }) => (<CallOverlay hasAudio={hasAudio} hasVideo={hasVideo} ref={ref}/>));
        this.$onChanges = ({ hasVideo, hasAudio }) => {
            if (!ref.current) {
                return;
            }
            if (hasVideo !== undefined) {
                ref.current.onChangeVideo(hasVideo.currentValue);
            }
            if (hasAudio !== undefined) {
                ref.current.onChangeAudio(hasAudio.currentValue);
            }
        };
        this.$onInit = () => {
            render(<OverlayWithProviders hasAudio={this.hasAudio} hasVideo={this.hasVideo}/>, $element[0]);
        };
    },
}).name;
